import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import ResourceCard from "./ResourceCard";
import Header from "./Header";
import Footer from "./Footer";
import { getAllResourcesByCategory } from "../services/resourceService";
import "./Common.css";

function ResourceDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedCategory = queryParams.get("category") || "Operational Guideline";

  const [loading, setLoading] = useState(true);
  const [resources, setResources] = useState([]);


  useEffect(() => {
    async function fetchResources() {
      try {
        setLoading(true);
        const data = await getAllResourcesByCategory(selectedCategory);
        setResources(data || []);
      } catch (error) {
        console.error("Error loading category resources:", error);
        setResources([]);
      } finally {
        setLoading(false);
      }
    }

    fetchResources();
  }, [selectedCategory]);

  if (loading) {
    return (
      <div>
        <Header />
        <section className="resource-section d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="text-center">
            <Spinner animation="border" variant="primary" role="status" className="mb-2" />
            <div style={{ fontWeight: "500" }}>Loading resources for {selectedCategory}...</div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  // Group dynamic resources by folderName
  const groupedResources = resources.reduce((acc, resource) => {
    const folder = resource.folderName || "General Documents";
    if (!acc[folder]) {
      acc[folder] = [];
    }
    acc[folder].push(resource);
    return acc;
  }, {});

  const hasResources = resources.length > 0;

  return (
    <div>
      <Header />
      <section className="resource-section">
        <Container>
          <h1 className="fw-bold text-center">Resource</h1>
          <h2 className="page-title">
            {selectedCategory}
          </h2>

          {hasResources ? (
            // Render dynamically loaded folders and files from API
            Object.entries(groupedResources).map(([folderName, files]) => (
              <div key={folderName} className="resource-box mb-4">
                <h5 className="resource-heading" style={{ fontSize: "20px", fontWeight: "600", color: "#000" }}>
                  {folderName}
                </h5>
                <Row className="g-3">
                  {files.map((file, index) => (
                    <Col lg={2} md={4} sm={6} key={file.resId || index}>
                      <ResourceCard item={file} />
                    </Col>
                  ))}
                </Row>
              </div>
            ))
          ) : (
            <div className="text-center py-5">
              <h5 style={{ color: "#888", fontWeight: "400" }}>No resources found for {selectedCategory}.</h5>
            </div>
          )}
        </Container>
      </section>
      <Footer />
    </div>
  );
}

export default ResourceDetails;